import { Component } from '@angular/core';
import { NewstrickerviewComponent } from '../../newstrickerview/newstrickerview.component';
import { AddNewsComponent } from '../../newstrickerview/add/add.component';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-newsticker-erp',
  imports: [NewstrickerviewComponent, AddNewsComponent, CommonModule],
  templateUrl: './newsticker-erp.component.html',
  styleUrl: './newsticker-erp.component.scss',
})
export class NewstickerErpComponent {
  news = [
    { id: 1, sentence: 'ERP News 2025' },
    { id: 2, sentence: 'ERP Important Update' },
  ];

  constructor(private router: Router) {}
  showCreate = false;

  handleAdd() {
    this.showCreate = true;
  }

  handleBackToList() {
    this.showCreate = false;
  }

  handleSave(news: any) {
    this.news.push(news);
    this.showCreate = false;
  }
  defaultSentence = 'Welcome ERP Users 2025';

  saveERPNews(data: any) {
    console.log('ERP saved:', data);
  }
}
